<template>
  <div class="get-token-container">
    <a-spin
      :spinning="loading"
      :tip="`${$t('authorize')}`"
      size="large"></a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import { tipMsg } from '@/utils/tipTools'
import AES from '@/utils/aes'

export default {
  name: 'GetToken',
  data () {
    return {
      loading: true
    }
  },
  created () {
    this.code = this.$route.query.code
    this.state = this.$route.query.state
    if (!Vue.prototype.$token.loadToken().access_token || Vue.prototype.$token.loadToken().access_token === 'null') {
      this.getToken()
    } else {
      this.$router.push('/')
    }
  },
  methods: {
    getToken () {
      this.loading = true
      const _this = this
      this.$token.getTokenFromService(this, this.code, (response) => {
        // alert('GetToken返回值：' + JSON.stringify(response))
        if (response.data.code === 400) {
          tipMsg('error', response.data.msg)
          this.$router.push('/')
        } else {
          // alert('token获取的返回值')
          // alert(JSON.stringify(response))
          if (response.data) {
            this.$token.savetoken(response.data)
            this.$cookies.set('access_token', AES.Encrypt(response.data.access_token))
            this.loading = false
            this.$router.push('/')
          } else {
            tipMsg('error', this.$t('authorizeFailed'))
            this.$router.push('/')
            this.loading = false
          }
        }
      }, function (error) {
        // alert('token获取失败，即将退出')
        _this.loading = false
        tipMsg('error', error)
        _this.$store.dispatch('LogOut')
        // _this.$router.push('/user/login')
      })
    }
  }
}
</script>

<style lang="less" scoped>

  .get-token-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /deep/.ant-spin {
    position: relative;
    z-index: 999;
  }

  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(100% - 24px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
